module.exports = __webpack_public_path__ + "static/media/img-news3.7d3a23e0.jpg";